// extracted by mini-css-extract-plugin
export default {"documents":"PurchaseTransferScreen_documents__65Mm9","cross":"PurchaseTransferScreen_cross__WYOnu","noDocuments":"PurchaseTransferScreen_noDocuments__6MKAn"};